import React from 'react';
import { MessageCircle, Check } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 bg-dark-100" data-id="element-14" data-mp="3ucx51ikqtt0s">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15" data-mp="3udyks0cpf3ou">
        <div className="text-center mb-16" data-id="element-16" data-mp="c70y9baodhp3">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-17" data-mp="c83ln98sh209">
            Tu Negocio Hace Un Trabajo Premium.{' '}
            <br className="hidden md:block" data-id="element-18" data-mp="m4yilnpeyucf" />
            <span className="text-gold" data-id="element-19" data-mp="m3nh5ujfxyoh">
              Es Hora De Que Tu Website Lo Demuestre.
            </span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto" data-id="element-20" data-mp="h3rbzrz0c17c">
            Empieza hoy con solo $25 y mira tu demo real en menos de 72 horas.
            Si te gusta, pagas el resto. Si no, solo se te cobra el demo. Sin
            contratos ni mensualidades obligatorias.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-21" data-mp="14td826k320b4">
          {/* WhatsApp Card */}
          <div className="border border-[#25D366]/30 rounded-3xl p-8 md:p-10 text-center relative overflow-hidden" data-id="element-22" data-mp="zua8h1mvgmaj">
            {/* Background image */}
            <img src="https://cdn.magicpatterns.com/uploads/f4TXKfANotJzXqWz17dwgk/heylloyd-image-1782678048806.png" alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover" data-id="element-23" data-mp="2h4sq6i8l9tub" />
            {/* Overlays for readability */}
            <div className="absolute inset-0 bg-dark/80" data-id="element-24" data-mp="2v2r11dnpb852"></div>
            <div className="absolute inset-0 bg-gradient-to-br from-[#25D366]/25 to-dark/90" data-id="element-25" data-mp="3023p21qb6l98"></div>
            <div className="absolute top-0 right-0 w-32 h-32 bg-[#25D366]/10 rounded-full blur-3xl" data-id="element-26" data-mp="34ssi3lhmzqah"></div>

            <div className="relative z-10" data-id="element-27" data-mp="39som3kqc3hq1">
              <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-[#25D366] text-white mb-6 shadow-[0_0_30px_rgba(37,211,102,0.4)]" data-id="element-28" data-mp="39rn7x7e0uf43">
                <MessageCircle className="w-10 h-10" data-id="element-29" data-mp="3iu4y1wwsrrwd" />
              </div>

              <h3 className="text-2xl font-bold text-white mb-2" data-id="element-30" data-mp="1jo3ftcizfx1e">
                CONTÁCTANOS POR WHATSAPP AHORA
              </h3>

              <p className="text-gray-300 mb-8" data-id="element-31" data-mp="1eqjsln4b49xb">
                Escríbenos "WEBSITE" y te respondemos hoy
              </p>

              <div className="space-y-3 text-left max-w-sm mx-auto mb-10" data-id="element-32" data-mp="1shyga795szap">
                <div className="flex items-center gap-3" data-id="element-33" data-mp="1np5adg1yfkx1">
                  <Check className="w-5 h-5 text-[#25D366]" data-id="element-34" data-mp="22ekx8kyd767g" />
                  <span className="text-white font-medium" data-id="element-35" data-mp="22d0511zivzcr">
                    Respuesta rápida
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-36" data-mp="2bg18eux07ccq">
                  <Check className="w-5 h-5 text-[#25D366]" data-id="element-37" data-mp="2bdf02t2agstg" />
                  <span className="text-white font-medium" data-id="element-38" data-mp="27ez788jj0q84">
                    Sin presión ni compromiso
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-39" data-mp="h3bb037ffl0l">
                  <Check className="w-5 h-5 text-[#25D366]" data-id="element-40" data-mp="d17wt6tdi2bm" />
                  <span className="text-white font-medium" data-id="element-41" data-mp="2vg6jury0f7q">
                    Te explicamos todo en minutos
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-42" data-mp="6ws2ei1etwod">
                  <Check className="w-5 h-5 text-[#25D366]" data-id="element-43" data-mp="3pcc7yj1j8uy4" />
                  <span className="text-white font-medium" data-id="element-44" data-mp="3uanm35yv1rm5">
                    Empezamos cuando tú estés listo
                  </span>
                </div>
              </div>

              <a href="https://wa.me/447311754270?text=WEBSITE" target="_blank" rel="noopener noreferrer" className="block w-full py-4 px-8 bg-[#25D366] hover:bg-[#20bd5a] text-white font-bold rounded-full transition-all transform hover:scale-105 shadow-lg" data-id="element-45" data-mp="3ffheiek49kqp">
                ESCRIBIR POR WHATSAPP AHORA →
              </a>
            </div>
          </div>

          {/* Summary Card */}
          <div className="bg-dark rounded-3xl border border-white/10 p-8 md:p-10" data-id="element-46" data-mp="19jd9kugjq6rd">
            <h3 className="text-xl font-bold text-white mb-8 text-center border-b border-white/10 pb-6" data-id="element-47" data-mp="35nt5yd8u80u3">
              RESUMEN RÁPIDO DE LA OFERTA
            </h3>

            <div className="space-y-6" data-id="element-48" data-mp="30mn8k248fpe8">
              <div className="flex justify-between items-center pb-4 border-b border-white/5" data-id="element-49" data-mp="2voc1u098hv08">
                <span className="text-gray-400" data-id="element-50" data-mp="2rojt9njubouv">Para empezar solo</span>
                <span className="text-gold font-bold text-right" data-id="element-51" data-mp="2mof83k7zm5yb">
                  $25 (tu demo)
                </span>
              </div>
              <div className="flex justify-between items-center pb-4 border-b border-white/5" data-id="element-52" data-mp="2hx6yoo6nqkl5">
                <span className="text-gray-400" data-id="element-53" data-mp="2czx8v7fcw6ws">Si te gusta, pagas</span>
                <span className="text-white font-bold text-right" data-id="element-54" data-mp="280ayr6utr6s7">
                  $225 restantes
                </span>
              </div>
              <div className="flex justify-between items-center pb-4 border-b border-white/5" data-id="element-55" data-mp="23xo4z0elfbsd">
                <span className="text-gray-400" data-id="element-56" data-mp="1yzmlied99agd">Si no te gusta</span>
                <span className="text-white font-bold text-right" data-id="element-57" data-mp="ehv8z6bymmde">
                  Solo pagas el demo
                </span>
              </div>
              <div className="flex justify-between items-center pb-4 border-b border-white/5" data-id="element-58" data-mp="ji9ikst7m4dj">
                <span className="text-gray-400" data-id="element-59" data-mp="nijknudvsan4">
                  Website profesional completo
                </span>
                <span className="text-white font-bold text-right" data-id="element-60" data-mp="seh3q8gj3v3l">
                  $250 en total
                </span>
              </div>
              <div className="flex justify-between items-center pb-4 border-b border-white/5" data-id="element-61" data-mp="3vws6mjlwe36b">
                <span className="text-gray-400" data-id="element-62" data-mp="4r0j7rzi94n7">Listo en</span>
                <span className="text-white font-bold text-right" data-id="element-63" data-mp="9hz3t3rj0ow9">
                  Menos de 72 horas
                </span>
              </div>
              <div className="flex justify-between items-center pb-4 border-b border-white/5" data-id="element-64" data-mp="386y00js69aui">
                <span className="text-gray-400" data-id="element-65" data-mp="3d60s73n1zml2">
                  Mensualidades obligatorias
                </span>
                <span className="text-white font-bold text-right" data-id="element-66" data-mp="kb0w7h6g47q6">
                  $0 — No hay
                </span>
              </div>
              <div className="flex justify-between items-center pb-4 border-b border-white/5" data-id="element-67" data-mp="t4w2isjb047e">
                <span className="text-gray-400" data-id="element-68" data-mp="t6qg1ls8wu1g">Mantenimiento opcional</span>
                <span className="text-white font-bold text-right" data-id="element-69" data-mp="p43qjrj1rl7f">
                  $30/mes si lo deseas
                </span>
              </div>
              <div className="flex justify-between items-center pb-4 border-b border-white/5" data-id="element-70" data-mp="3skkagtwpgb8p">
                <span className="text-gray-400" data-id="element-71" data-mp="aexkbjlskuq1">Contrato largo</span>
                <span className="text-white font-bold text-right" data-id="element-72" data-mp="ac1lzu618412">
                  No existe
                </span>
              </div>
              <div className="flex justify-between items-center" data-id="element-73" data-mp="1lsrwvqlehk10">
                <span className="text-gray-400" data-id="element-74" data-mp="1lve0jf567fdy">Sorpresas de precio</span>
                <span className="text-white font-bold text-right" data-id="element-75" data-mp="1gu89rmv2m272">
                  No existen
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}